import {
  anAddInsightComment,
  anAddInsightCommentsById,
  anUpdateInsight,
  anUpdateInsightResolution,
  anUpdateInsightsById,
  mockUpdateInsightResolutionMutationOperationMutation,
  mockUpdateInsightResolutionOperationMutation,
  mockUpdateInsightsResolutionOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateInsightResolutionMutationData = {
  __typename: 'Mutation' as const,
  updateInsightResolution: anUpdateInsightResolution(),
};

export const updateInsightResolutionOperationData = {
  __typename: 'Mutation' as const,
  addInsightComment: anAddInsightComment(),
  updateInsight: anUpdateInsight(),
};

export const updateInsightResolutionOperationWithoutCommentData = {
  __typename: 'Mutation' as const,
  updateInsight: anUpdateInsight(),
};

export const updateInsightsResolutionOperationData = {
  __typename: 'Mutation' as const,
  addInsightCommentsById: anAddInsightCommentsById(),
  updateInsightsById: anUpdateInsightsById(),
};

export const handlers = [
  mockUpdateInsightResolutionMutationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: updateInsightResolutionMutationData,
      });
    }
  ),
  mockUpdateInsightResolutionOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: updateInsightResolutionOperationData,
      });
    }
  ),
  mockUpdateInsightsResolutionOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: updateInsightsResolutionOperationData,
      });
    }
  ),
];
